import PropTypes from 'prop-types';

import { DimensionPropType } from './dimension';
import { FulfillmentPropType } from './fulfillment';
import { OrderItemPropType } from './order-item';
import { RatePropType } from './rate';
import { WeightPropType } from './weight';

export const FulfillmentPlanPropType = PropTypes.shape({
  fulfillmentPlanId: PropTypes.string,
  packingSlipTemplateId: PropTypes.string,
  shipmentNotificationTemplateId: PropTypes.string,
  deliveryNotificationTemplateId: PropTypes.string,
  shipFromId: PropTypes.string,
  weight: WeightPropType,
  dimensions: DimensionPropType,
  shippingAccountName: PropTypes.string,
  shipDateTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  rate: RatePropType,
  labelProviderId: PropTypes.string,
  serviceId: PropTypes.string,
  packageTypeId: PropTypes.string,
  confirmation: PropTypes.string,
  items: PropTypes.arrayOf(OrderItemPropType),
  fulfillments: PropTypes.arrayOf(FulfillmentPropType),
  properties: PropTypes.shape({
    needsCustoms: PropTypes.bool,
    isInternational: PropTypes.bool,
  }),
  fulfillmentType: PropTypes.oneOf(['Shipment', 'External', 'Manual']),
});

/**
 * @typedef FulfillmentPlanPropType
 * @property {string} fulfillmentPlanId
 * @property {string} packingSlipTemplateId
 * @property {string} shipmentNotificationTemplateId
 * @property {string} deliveryNotificationTemplateId
 * @property {string} shipFromId
 * @property {WeightPropType} weight
 * @property {DimensionsPropType} dimensions
 * @property {string} shippingAccountName
 * @property {string|Date} shipDateTime
 * @property {RatePropType} rate
 * @property {string} labelProviderId
 * @property {string} serviceId
 * @property {string} packageTypeId
 * @property {string} confirmation
 * @property {OrderItemPropType[]} items
 * @property {FulfillmentPropType[]} fulfillments
 * @property {object} properties
 * @property {boolean} properties.needsCustoms
 * @property {boolean} properties.isInternational
 * @property {('Shipment'|'External'|'Manual')} fulfillmentType
 * @property {object} [pickBatchExceptionInfo]
 * @property {number} [pickBatchExceptionInfo.exceptionType]
 * @property {{[key: string]: string}} [pickBatchExceptionInfo.productExceptions]
 * @property {object} [pickBatchExceptionInfo.reporter]
 * @property {string} [pickBatchExceptionInfo.reporter.userId]
 * @property {string} [pickBatchExceptionInfo.reporter.name]
 */
